<div mat-dialog-content>
    <h3>{{ this.question | translate}}</h3>
</div>
<mat-form-field *ngIf="this.is_note"  style="width: 100%">
    <mat-label>{{'note' | translate}}</mat-label>
    <textarea #notes matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
      cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
  </mat-form-field>
<div mat-dialog-actions>
    <button mat-button color="warn" (click)="onNoYesClick(false)">{{ this.rejectText | translate}}</button>
    <button mat-button color="primary" (click)="onNoYesClick(true)">{{ this.confirmText | translate}}</button>
</div>